var _defs, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _rect, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgM1IconModem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ccc;}.cls-1,.cls-2,.cls-3{stroke-width:0px;}.cls-2{fill:#000;}.cls-3{fill:#fff;}.cls-4{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M248.53,534.21c-3.22,0-5.84-2.62-5.84-5.84V111.63c0-3.22,2.62-5.84,5.84-5.84h127.84c2.02,0,3.87,1.02,4.95,2.74l15.09,24.06c.58.93.89,2.01.89,3.1v371.63c0,1.08-.3,2.13-.86,3.04l-15.09,21.05-.04.06c-1.08,1.71-2.93,2.74-4.95,2.74h-127.84Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M376.37,108.29c1.16,0,2.22.59,2.83,1.57l15.09,24.06c.33.53.51,1.15.51,1.78v371.63c0,.59-.16,1.17-.45,1.67l-14.98,20.91-.09.13-.08.13c-.62.98-1.67,1.57-2.83,1.57h-127.84c-1.84,0-3.34-1.5-3.34-3.34V111.63c0-1.84,1.5-3.34,3.34-3.34h127.84M376.37,103.29h-127.84c-4.61,0-8.34,3.73-8.34,8.34v416.74c0,4.61,3.73,8.34,8.34,8.34h127.84c2.87,0,5.54-1.48,7.07-3.91l15.09-21.06c.83-1.33,1.28-2.86,1.28-4.43V135.69c0-1.57-.44-3.1-1.28-4.43l-15.09-24.06c-1.53-2.43-4.2-3.91-7.07-3.91h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.03,130.45h51.11c10.98,0,19.89,8.91,19.89,19.89v293.7c0,10.98-8.91,19.89-19.89,19.89h-51.11c-10.98,0-19.89-8.91-19.89-19.89V150.34c0-10.98,8.91-19.89,19.89-19.89Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M336.14,131.95c10.14,0,18.39,8.25,18.39,18.39v293.7c0,10.14-8.25,18.39-18.39,18.39h-51.11c-10.14,0-18.39-8.25-18.39-18.39V150.34c0-10.14,8.25-18.39,18.39-18.39h51.11M336.14,128.95h-51.11c-11.81,0-21.39,9.57-21.39,21.39v293.7c0,11.81,9.57,21.39,21.39,21.39h51.11c11.81,0,21.39-9.57,21.39-21.39V150.34c0-11.81-9.57-21.39-21.39-21.39h0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 310.59,
    cy: 216.48,
    r: 4.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 310.59,
    cy: 235.38,
    r: 4.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 310.59,
    cy: 254.28,
    r: 4.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 310.59,
    cy: 273.18,
    r: 4.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 310.59,
    cy: 292.08,
    r: 4.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 310.59,
    cy: 310.98,
    r: 4.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 310.59,
    cy: 329.87,
    r: 4.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 310.59,
    cy: 348.77,
    r: 4.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 310.59,
    cy: 367.67,
    r: 4.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 310.59,
    cy: 386.57,
    r: 4.5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 310.59,
    cy: 405.47,
    r: 4.5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 310.59,
    cy: 424.37,
    r: 4.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 306.09,
    y: 163.52,
    width: 9,
    height: 27.98,
    rx: 4.5,
    ry: 4.5,
    transform: "translate(621.18 355.03) rotate(180)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 377.99,
    y1: 122.89,
    x2: 377.99,
    y2: 517.11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM1IconModem);
export default __webpack_public_path__ + "static/media/m1-icon-modem.59041ef04099a9e5c137efe738e33eca.svg";
export { ForwardRef as ReactComponent };